// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"264":"da00dbf4","370":"8c720d95","855":"f850501c"}[chunkId] + ".js";
};